import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import moment from 'moment'
import Popup from 'react-popup/dist'
import PropTypes from 'prop-types'

import { canUseFeature, userPermissionRoles } from '../../utils/userPermissions'
import {
  downloadCargoManifestTemplate,
  exportTerminalVisitsToExcel,
  exportYaraTerminalVisitsToExcel,
  exportBotlekTerminalVisitsToExcel
} from '../../js/rest'
import ExportExcelYara from './exportexcel/ExportExcelYara'
import { clearAuth } from '../../pages/login/actions'
import ExportExcel from './exportexcel/ExportExcel'
import './Menu.scss'
import { APP_TERMINAL_IDS, USER_FEATURES } from '../../js/constants'
import { handleFetchError } from '../../js/sentry'
import UserMenuOptions from './userMenuOptions/UserMenuOptions'
import MenuItem from './menuItem/MenuItem'

class Menu extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showUserMenuOptions: false
    }
  }

  static propTypes = {
    onShowCargoManifest: PropTypes.func.isRequired,
    onSelectTerminal: PropTypes.func.isRequired
  }

  render() {
    const { planner: isPlanner, orderAdmin: isOrderAdmin, quayCoordinator: isQuayCoorinator } = userPermissionRoles(
      this.props.login.auth.roles
    )

    const terminalId = this.props.login.auth.terminalId

    const showUploadManifestTemplate =
      terminalId === APP_TERMINAL_IDS.cargillIzegem || terminalId === APP_TERMINAL_IDS.teqplay
    const showDownloadManifestTemplate =
      terminalId === APP_TERMINAL_IDS.cargillIzegem || terminalId === APP_TERMINAL_IDS.teqplay

    const { pathname } = this.props.location
    return (
      <div className="menu-wrapper">
        <div className="main-menu-button">
          <Link to="/">
            <i className="fa fa-columns" aria-hidden="true" />
            <span className="logo">Terminal Planner</span>
          </Link>
        </div>

        <div className="menu-buttons-wrapper">
          <MenuItem
            label="Map"
            isActive={pathname.includes('/ships/map')}
            icon="fas fa-map-marked"
            show={!isQuayCoorinator}
            action={() => this.props.history.push('/ships/map')}
          />
          <MenuItem
            label="Resource planning"
            isActive={pathname.includes('/resourceplanning')}
            icon="fa fa-chart-bar"
            show={!isQuayCoorinator}
            action={() => this.props.history.push('/resourceplanning')}
          />
          <MenuItem
            label="Statistics"
            isActive={pathname.includes('/statistics/kpi')}
            icon="fa fa-chart-pie"
            show={showStatisticsMenu({ isPlanner, isOrderAdmin, userSettings: this.props.login.auth.userSettings })}
            action={() => this.props.history.push('/statistics/kpi')}
          />
          <MenuItem
            label="Export"
            isActive={false}
            icon="fas fa-download"
            show={isPlanner || isOrderAdmin}
            options={[
              {
                label: 'Export Yara planning to Excel',
                action: () => showYaraExportExcel(this.props),
                show: this.props.login.auth.terminalId === APP_TERMINAL_IDS.yara
              },
              {
                label: 'Export terminal visits to Excel',
                action: () => showExportExcel(this.props)
              },
              {
                label: 'Experimental botlek export',
                action: () => showBotlekExportExcel(this.props),
                show:
                  this.props.login.auth.terminalId === APP_TERMINAL_IDS.cargillBotlek &&
                  canUseFeature(USER_FEATURES.botlekExport, this.props.login.auth.userSettings)
              }
            ]}
          />
          <MenuItem
            label="Configuration"
            isActive={pathname.includes('/configuration/')}
            icon="fa fa-cog"
            show={isPlanner}
            options={[
              {
                label: 'Manage terminal',
                action: () => this.props.history.push('/configuration/terminal')
              },
              {
                label: 'Upload cargo manifest template',
                // TODO: currently hardcoded for Cargill Izegem and demo terminal nltpl/teqplay. Make this configurable
                show: showUploadManifestTemplate,
                action: this.props.onShowCargoManifest
              },
              {
                label: 'Download cargo manifest template',
                show: showDownloadManifestTemplate,
                action: () => downloadManifest(this.props)
              }
            ]}
          />
        </div>

        <div
          className="user-management"
          onMouseEnter={() => this.changeUserMenuOptionDisplay(true)}
          onMouseLeave={() => this.changeUserMenuOptionDisplay(false)}
        >
          <div className="user-wrapper">
            <i className="fa fa-user-circle fa-lg" aria-hidden="true" />
            <span className="username-text">{this.props.login.auth.username}</span>
            {this.state.showUserMenuOptions && (
              <UserMenuOptions
                userTerminals={this.props.login.userTerminals}
                currentTerminalId={this.props.login.auth.terminalId}
                onSelectTerminal={this.props.onSelectTerminal}
                onLogout={() => handleLogout(this.props)}
              />
            )}
          </div>
        </div>
      </div>
    )
  }

  changeUserMenuOptionDisplay = show => {
    if (this.state.showUserMenuOptions !== show) {
      this.setState({ showUserMenuOptions: show })
    }
  }
}

export default connect(state => state)(withRouter(Menu))

/**
 * Checks if 'Statistics' menu should be displayed for user
 * @param auth details for logged-in user
 */
function showStatisticsMenu({ isPlanner, isOrderAdmin, userSettings }) {
  return (isPlanner || isOrderAdmin) && canUseFeature(USER_FEATURES.KPI, userSettings)
}

async function downloadManifest(props) {
  const { terminalId, token } = props.login.auth
  try {
    await downloadCargoManifestTemplate(terminalId, token, props.customFetch)
  } catch (err) {
    handleFetchError(err)
  }
}

/**
 * Displays a popup for exporting terminal visits to Excel for Yara
 * @param props
 */
function showYaraExportExcel(props) {
  const handleYaraExportExcel = (from, to, shipType, administrativeFormat) => {
    exportYaraTerminalVisitsToExcel(
      props.login.auth.terminalId,
      from,
      to,
      shipType,
      administrativeFormat,
      props.login.auth.token,
      props.customFetch
    )

    Popup.close()
  }

  Popup.create({
    title: 'Export Yara planning Excel',
    className: 'export-excel-yara no-spacing',
    content: (
      <ExportExcelYara
        from={props.app.present.dateRange.from}
        to={props.app.present.dateRange.to}
        onExportExcel={handleYaraExportExcel}
      />
    )
  })
}

/**
 * Displays a popup for exporting terminal visits to Excel for Botlek
 * @param props
 */
function showBotlekExportExcel(props) {
  const handleBotlekExportExcel = (from, to) => {
    exportBotlekTerminalVisitsToExcel(from, to, props.login.auth.token, props.customFetch)

    Popup.close()
  }

  Popup.create({
    title: 'Export Botlek planning Excel',
    className: 'export-excel no-spacing',
    content: (
      <ExportExcel
        from={moment().hours(0).minutes(0).seconds(0).valueOf()}
        to={moment().hours(0).minutes(0).seconds(0).add(4, 'weeks').valueOf()}
        onExportExcel={handleBotlekExportExcel}
        hideTime={true}
      />
    )
  })
}

/**
 * Logout
 */
function handleLogout(props) {
  props.dispatch(clearAuth())
}

/**
 * Displays a popup for exporting terminal visit to Excel
 * @param props
 */
function showExportExcel(props) {
  const handleExportExcel = (from, to) => {
    exportTerminalVisitsToExcel(props.login.auth.terminalId, from, to, props.login.auth.token, props.customFetch)

    Popup.close()
  }
  Popup.create({
    title: 'Export terminal visits to Excel',
    className: 'export-excel no-spacing',
    content: (
      <ExportExcel
        from={props.app.present.dateRange.from}
        to={props.app.present.dateRange.to}
        onExportExcel={handleExportExcel}
      />
    )
  })
}
